var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoggedIn
    ? _c("div", { staticClass: "geoloc-block" }, [
        _vm.geolocationEnabled &&
        ((_vm.geolocationMessage.errorCode &&
          _vm.geolocationMessage.errorCode === 612) ||
          (_vm.errorMsgLocalStorage && _vm.errorMsgLocalStorage === "612"))
          ? _c(
              "div",
              { staticClass: "betslip-gc-msg" },
              [
                _c("h3", { staticClass: "gc-text" }, [
                  _vm._v(_vm._s(_vm.$t("BetSlip.geolocation.overlay.header")))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "gc-text" }, [
                  _vm._v(_vm._s(_vm.$t("BetSlip.geolocation.overlay.content")))
                ]),
                _vm._v(" "),
                _vm.brandKey === "boyd"
                  ? _c("p", {
                      staticClass: "gc-plugin-msg",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("BetSlip.geolocation.overlay.tryagain")
                        )
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    staticClass: "gc-link",
                    attrs: { block: "" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.viewGeoLocationDetails()
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "gc-link" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("BetSlip.geoLocation.Details")))
                      ])
                    ])
                  ]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.geolocationEnabled &&
        (_vm.geolocationMessage.errorCode === 999 ||
          _vm.errorMsgLocalStorage === "999")
          ? _c(
              "div",
              { staticClass: "betslip-gc-msg" },
              [
                _c("h3", { staticClass: "gc-text" }, [
                  _vm._v(_vm._s(_vm.$t("BetSlip.geolocation.overlay.header")))
                ]),
                _vm._v(" "),
                _vm.brandKey === "boyd"
                  ? _c("p", {
                      staticClass: "gc-plugin-msg",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("BetSlip.geolocation.overlay.tryagain")
                        )
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    staticClass: "gc-link",
                    attrs: { block: "" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.viewGeoLocationDetails()
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "gc-link" }, [
                      _vm._v(_vm._s(_vm.$t("BetSlip.geoLocation.Details")))
                    ])
                  ]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.geolocationEnabled &&
        !_vm.isOpenedFromWebView &&
        !_vm.mobileBigAndBelow
          ? _c("div", [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        !_vm.isGeolocated &&
                        !_vm.geolocationSubmitInternalError,
                      expression:
                        "!isGeolocated && !geolocationSubmitInternalError"
                    }
                  ],
                  staticClass: "not-geolocated"
                },
                [
                  _vm.geolocationMessage.errorCode === "verify"
                    ? _c(
                        "div",
                        {
                          key:
                            _vm.geolocationMessage.errorCode +
                            "-" +
                            Math.random()
                        },
                        [
                          _c("p", { staticClass: "pls-wait" }, [
                            _vm._v(
                              _vm._s(_vm.$t("BetSlip.geoLocation.pleaseWait"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "verify" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("BetSlip.geoLocation.VerifyingLocation")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "loader-container" },
                            [_c("circle-loader")],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.geolocationMessage.errorCode === 999 ||
                  _vm.geolocationMessage.errorCode === 612 ||
                  _vm.errorMsgLocalStorage === "999" ||
                    _vm.errorMsgLocalStorage === "612"
                    ? _c(
                        "div",
                        {
                          key:
                            _vm.geolocationMessage.errorCode +
                            "-" +
                            Math.random()
                        },
                        [
                          _c("p", { key: _vm.state + "-" + Math.random() }, [
                            _vm._v(
                              _vm._s(_vm.$t("BetSlip.notLocated." + _vm.state))
                            )
                          ]),
                          _vm._v(" "),
                          _vm.isHardGeolocation
                            ? _c(
                                "p",
                                { key: _vm.state + "-" + Math.random() },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("BetSlip.tryAgain." + _vm.state)
                                    )
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              !_vm.isGeolocated && _vm.geolocationSubmitInternalError
                ? _c("div", { staticClass: "not-geolocated" }, [
                    _c("p", { staticClass: "pls-wait" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            version: "1.1",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 130.2 130.2"
                          }
                        },
                        [
                          _c("circle", {
                            staticClass: "path circle",
                            attrs: {
                              fill: "none",
                              stroke: "#fff",
                              "stroke-width": "6",
                              "stroke-miterlimit": "10",
                              cx: "65.1",
                              cy: "65.1",
                              r: "62.1"
                            }
                          }),
                          _vm._v(" "),
                          _c("line", {
                            staticClass: "path line",
                            attrs: {
                              fill: "none",
                              stroke: "#fff",
                              "stroke-width": "6",
                              "stroke-linecap": "round",
                              "stroke-miterlimit": "10",
                              x1: "34.4",
                              y1: "37.9",
                              x2: "95.8",
                              y2: "92.3"
                            }
                          }),
                          _vm._v(" "),
                          _c("line", {
                            staticClass: "path line",
                            attrs: {
                              fill: "none",
                              stroke: "#fff",
                              "stroke-width": "6",
                              "stroke-linecap": "round",
                              "stroke-miterlimit": "10",
                              x1: "95.8",
                              y1: "38",
                              x2: "34.4",
                              y2: "92.2"
                            }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "verify" }, [
                      _vm._v(
                        _vm._s(_vm.$t("Geolocation.ErrorMessage.NotVerified"))
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isGeolocated
                ? _c("div", { staticClass: "checkmark" }, [_c("check-mark")], 1)
                : _vm._e()
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-633707e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-633707e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/GeolocationIndicator.vue
// module id = null
// module chunks = 